import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupScreenshotWarningContentProps } from './msg-group-screenshot-warning-content';
import { MsgGroupScreenshotWarningContent } from './msg-group-screenshot-warning-content';

export interface MsgGroupScreenshotWarningPreviewProps
  extends MsgGroupScreenshotWarningContentProps {}

export const MsgGroupScreenshotWarningPreview = memo(function MsgGroupScreenshotWarningPreview({
  message,
}: MsgGroupScreenshotWarningPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupScreenshotWarningContent message={message} />
    </LastMessageSystem>
  );
});
